import { render, staticRenderFns } from "./EventAttendeeForm.vue?vue&type=template&id=38582e24&"
import script from "./EventAttendeeFormVue.ts?vue&type=script&lang=ts&"
export * from "./EventAttendeeFormVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports